import React from "react";
import EventCard from "../EventCard/EventCard";

const EventCardColumnLoading = ({ loading = false }: { loading?: boolean }) => {
  if (!loading) return null;

  return (
    <>
      <EventCard loading />
      <EventCard loading />
      <EventCard loading />
    </>
  );
};

export default EventCardColumnLoading;
